<template>
  <div class="auto-list_col_centered">
    <div>
      <div class="check-list-flags">
        <div class="check-list-flags__flag is-weight">
          ВЕС
          <i
            :class="`el-icon-${
              response.weightStatus === 'success' ? 'top' : 'bottom'
            }`"
          />
        </div>
        <div
          :class="['check-list-flags__flag is-ttn', response['ttn-status']]"
          @click.stop="handlerClick('onTTNClick')"
        >
          ТТН
        </div>
        <div @click.stop="handlerClick('onPaymentClick')">
          <payment-status :response="response" />
        </div>
        <div @click.stop="handlerClick('onActClick')">
          <act-status :response="response" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActStatus from '@/views/LoadDay/Modals/Act/ActStatus'
import PaymentStatus from '@/views/LoadDay/Modals/Payments/PaymentStatus'

export default {
  name: 'ButtonsForModals',
  components: {
    ActStatus,
    PaymentStatus,
  },
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    onTTNClick: {
      type: Function,
      default: () => {},
    },
    onPaymentClick: {
      type: Function,
      default: () => {},
    },
    onActClick: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    handlerClick(callFunction) {
      this[callFunction](this.response)
    },
  },
}
</script>

<style lang="sass">
.check-list-flags
  display: flex
  font-size: 20px
  line-height: 21px
  margin-left: -5px
  margin-right: -5px

  &__flag
    padding-right: 5px
    padding-left: 5px
    color: #d7d7d7
    font-weight: 900
    display: flex
    align-items: center

    &.is-weight
      &.danger
        color: #f00

      &.warning
        color: #ffb800

      &.success
        color: #00bf40

    &.is-ttn
      &.danger
        color: #f00

      &.warning
        color: #ffb800

      &.success
        color: #00bf40

    &.is-opl
      &.active
        color: #ffb800

    &.is-act
      &.active
        color: #00bf40
</style>
